
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';

export const RegionChart: React.FC = () => {
  // Mock data - would be replaced with actual API data
  const data = [
    {
      name: 'Región 1',
      ocupacion: 78,
    },
    {
      name: 'Región 2',
      ocupacion: 62,
    },
    {
      name: 'Región 3',
      ocupacion: 85,
    },
    {
      name: 'Región 4',
      ocupacion: 49,
    },
    {
      name: 'Región 5',
      ocupacion: 70,
    },
  ];

  const config = {
    ocupacion: {
      label: 'Ocupación (%)',
      color: '#8884d8',
    }
  };

  return (
    <Card className="col-span-1">
      <CardHeader>
        <CardTitle>Porcentaje de Ocupación por Región</CardTitle>
      </CardHeader>
      <CardContent className="pt-4">
        <ChartContainer className="aspect-video h-64" config={config}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis label={{ value: '%', position: 'insideLeft', angle: -90 }} />
              <ChartTooltip
                content={<ChartTooltipContent />}
              />
              <Bar
                dataKey="ocupacion"
                fill="#8884d8"
                radius={[4, 4, 0, 0]}
                barSize={30}
              />
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};
